var _polygon, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendenteAvaliacao({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.14,
    y: 29.79,
    width: 372.27,
    height: 214.3,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.77,39.7a2.83,2.83,0,1,1-2.83-2.83A2.83,2.83,0,0,1,54.77,39.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.25,39.7a2.84,2.84,0,1,1-2.83-2.83A2.83,2.83,0,0,1,65.25,39.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.73,39.7a2.84,2.84,0,1,1-2.83-2.83A2.83,2.83,0,0,1,75.73,39.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.78,
    y: 224.87,
    width: 191.81,
    height: 110.41,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.34,230a1.46,1.46,0,1,1-1.46-1.46A1.46,1.46,0,0,1,297.34,230Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.74,230a1.46,1.46,0,1,1-1.46-1.46A1.46,1.46,0,0,1,302.74,230Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.14,230a1.46,1.46,0,1,1-1.46-1.46A1.46,1.46,0,0,1,308.14,230Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.47,
    y: 277.58,
    width: 103.36,
    height: 130.13,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.82,407.72s0-.22,0-.64,0-1,0-1.82c0-1.63,0-4,0-7.08,0-6.19-.06-15.21-.1-26.65,0-22.86-.1-55.35-.17-93.95l.35.36L34.48,278h0l.39-.4c0,48.19,0,93-.07,130.14l-.32-.33,75,.17,21,.08,5.53,0c1.26,0,1.92,0,1.92,0l-1.85,0-5.46,0-20.88.08L34.47,408h-.33v-.33c0-37.17,0-82-.07-130.14v-.39h.41l103.34,0h.36v.35c-.08,38.7-.14,71.27-.18,94.18,0,11.4-.07,20.4-.1,26.57,0,3.05,0,5.4,0,7,0,.77,0,1.36,0,1.78S137.82,407.72,137.82,407.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.82,342.82c0,.21-22.95.39-51.24.39s-51.25-.18-51.25-.39,22.94-.4,51.25-.4S137.82,342.6,137.82,342.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.82,376.72c0,.22-22.95.39-51.24.39s-51.25-.17-51.25-.39,22.94-.4,51.25-.4S137.82,376.5,137.82,376.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.82,310.2c0,.22-22.95.39-51.24.39s-51.25-.17-51.25-.39,22.94-.4,51.25-.4S137.82,310,137.82,310.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.47,295.45c0,.21-15.74.39-35.15.39s-35.16-.18-35.16-.39,15.74-.4,35.16-.4S122.47,295.23,122.47,295.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.47,326.51c0,.22-15.74.39-35.15.39s-35.16-.17-35.16-.39,15.74-.4,35.16-.4S122.47,326.29,122.47,326.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.63,393.41c0,.21-14.43.39-32.23.39s-32.24-.18-32.24-.39,14.43-.4,32.24-.4S116.63,393.19,116.63,393.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.47,359.71c0,.21-15.74.39-35.15.39s-35.16-.18-35.16-.39,15.74-.4,35.16-.4S122.47,359.49,122.47,359.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.72 443.97 256.72 471.97 297.66 471.97 342.83 471.97 342.83 443.97 256.72 443.97",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.11 436.15 253.11 443.97 345.84 443.97 345.84 436.15 297.66 436.15 253.11 436.15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.47 471.97 342.83 471.97 342.83 443.97 345.84 443.97 345.84 436.15 297.66 436.15 297.66 443.25 299.47 471.97",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.76,
    y: 448.49,
    width: 17.46,
    height: 4.21,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.51,
    y: 457.97,
    width: 22.42,
    height: 8.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.97 408.18 269.97 436.18 310.91 436.18 356.07 436.18 356.07 408.18 269.97 408.18",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.35 400.36 266.35 408.18 359.08 408.18 359.08 400.36 310.91 400.36 266.35 400.36",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.72 436.18 356.07 436.18 356.07 408.18 359.08 408.18 359.08 400.36 310.91 400.36 310.91 407.46 312.72 436.18",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.01,
    y: 412.7,
    width: 17.46,
    height: 4.21,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.76,
    y: 422.18,
    width: 22.42,
    height: 8.9,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "65.44 53.6 65.44 286.3 450.8 286.3 450.8 81.92 169.13 81.92 168.78 53.6 65.44 53.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.28 85.52 167.92 58.95 263.26 58.95 263.26 85.52 168.28 85.52",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.26,
    y: 63.89,
    width: 94.06,
    height: 21.62,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.1 85.52 357.31 66.5 450.8 66.5 450.8 85.52 357.1 85.52",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.25,72.23c0,.15-14.82.26-33.09.26s-33.1-.11-33.1-.26S97.87,72,116.16,72,149.25,72.09,149.25,72.23Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.16,72.23c0,.15-14.82.26-33.09.26s-33.1-.11-33.1-.26,14.81-.26,33.1-.26S249.16,72.09,249.16,72.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.14,76c0,.14-14.82.26-33.1.26s-33.1-.12-33.1-.26,14.82-.26,33.1-.26S345.14,75.86,345.14,76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.35,76.74c0,.15-14.82.27-33.1.27s-33.1-.12-33.1-.27,14.82-.26,33.1-.26S438.35,76.6,438.35,76.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.44,
    y: 83.49,
    width: 385.36,
    height: 22.7,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.44,
    y: 104.66,
    width: 183.72,
    height: 22.7,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.31,
    y: 104.66,
    width: 93.49,
    height: 22.7,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.41,
    y: 156.28,
    width: 133.78,
    height: 100.55,
    transform: "translate(-0.22 0.17) rotate(-0.06)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "90.46 256.91 137.12 194.35 166.11 233.43 185.72 212.5 224.24 256.76 90.46 256.91"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178.35,186.65a10.54,10.54,0,1,1-10.55-10.52A10.55,10.55,0,0,1,178.35,186.65Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M325.23,158.66c0,.15-12.86.26-28.72.26s-28.72-.11-28.72-.26,12.86-.26,28.72-.26S325.23,158.52,325.23,158.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.06,177.93c0,.14-32.3.26-72.13.26s-72.14-.12-72.14-.26,32.29-.26,72.14-.26S412.06,177.78,412.06,177.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.06,190.49c0,.14-32.3.26-72.13.26s-72.14-.12-72.14-.26,32.29-.26,72.14-.26S412.06,190.34,412.06,190.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.06,203c0,.15-32.3.27-72.13.27s-72.14-.12-72.14-.27,32.29-.26,72.14-.26S412.06,202.9,412.06,203Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.06,215.6c0,.15-32.3.26-72.13.26s-72.14-.11-72.14-.26,32.29-.26,72.14-.26S412.06,215.46,412.06,215.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.06,228.16c0,.15-32.3.26-72.13.26s-72.14-.11-72.14-.26,32.29-.26,72.14-.26S412.06,228,412.06,228.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.06,240.72c0,.15-32.3.26-72.13.26s-72.14-.11-72.14-.26,32.29-.26,72.14-.26S412.06,240.58,412.06,240.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.06,251.39c0,.15-32.3.26-72.13.26s-72.14-.11-72.14-.26,32.29-.26,72.14-.26S412.06,251.25,412.06,251.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.44,53.6l103.34-.14h.14v.14q.18,14.1.38,29.89l-.16-.16,281.66-.09h.25v.25c0,62.75,0,131.36,0,202.81v.26h-.4L65.44,286.5h-.2v-.2c.12-142.56.2-231.06.2-232.7,0,1.64.08,90.14.2,232.7l-.2-.2L450.66,286h.14l-.26.26c0-71.45,0-140.06,0-202.81l.24.25-281.66-.09H169v-.16q-.16-15.78-.33-29.89l.14.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.19,115.72c0,.14-11.21.26-25,.26s-25-.12-25-.26,11.21-.26,25-.26S136.19,115.57,136.19,115.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.25,127.42c-.14,0-.26-4.93-.26-11s.12-11,.26-11,.26,4.92.26,11S157.4,127.42,157.25,127.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.91,116.65c0,.15-10,.26-22.46.26S183,116.8,183,116.65s10.06-.26,22.46-.26S227.91,116.51,227.91,116.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.43,116.18c0,.15-12.26.27-27.37.27s-27.38-.12-27.38-.27,12.25-.26,27.38-.26S439.43,116,439.43,116.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.38,116.65c0,.15-10.06.26-22.46.26s-22.47-.11-22.47-.26,10.06-.26,22.47-.26S323.38,116.51,323.38,116.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.8,127.36l-1.69,0-4.95,0-18.86.06-68,.09h-.21v-.22c0-7.19,0-14.8,0-22.7l.23.23-99.18,0h-9l.26-.26v23h-.26l-130.89-.09-38.76-.08-10.45,0-2.7,0c-.61,0-.92,0-.92,0s.31,0,.92,0l2.7,0,10.45,0,38.76-.08,130.89-.09-.26.26v-23h9.23l99.18,0h.23v.23c0,7.9,0,15.51,0,22.7l-.22-.21,68,.09,18.86.06,4.95,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cursor--inject-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "428.8 157.15 438.4 185.89 441.84 177.03 453.67 190.39 458.12 186.41 446.29 173.05 455.12 170.43 428.8 157.15",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,158.54a50.49,50.49,0,0,1-7.13.38,49.24,49.24,0,0,1-7.14-.14,48.76,48.76,0,0,1,7.13-.38A47.59,47.59,0,0,1,424,158.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.22,155a18.86,18.86,0,0,1-2.47-1.58c-1.49-1-3.53-2.48-5.76-4.11s-4.24-3.13-5.67-4.23a16.32,16.32,0,0,1-2.26-1.88,15.82,15.82,0,0,1,2.47,1.57c1.49,1,3.53,2.49,5.77,4.12s4.23,3.13,5.67,4.23A15.77,15.77,0,0,1,427.22,155Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.68,152.33a27.31,27.31,0,0,1-.56-4.92c-.09-1.22-.16-2.33-.24-3.49a13.81,13.81,0,0,1-.1-1.44c.25-.07.68,2.17.86,4.89A21.5,21.5,0,0,1,430.68,152.33Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.59,452.45v20.17l40.68-.19c-.3-4.09-22.62-12.25-22.62-12.25l.44-7.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.17,458.35a1.77,1.77,0,0,0-1.11,2,1.59,1.59,0,0,0,1.88,1.19,1.87,1.87,0,0,0,1.16-2.14,1.62,1.62,0,0,0-2.08-1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.59,472.62V469.4l38.84.46s2,1.22,1.84,2.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.65,460.57c0,.21-1,.32-2,1s-1.47,1.58-1.65,1.5.09-1.29,1.27-2.11S214.69,460.37,214.65,460.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,462.43c.05.21-.81.57-1.46,1.47s-.84,1.83-1,1.83-.34-1.19.5-2.29S220,462.23,220,462.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.37,467.57c-.17.05-.46-1,0-2.14s1.4-1.63,1.49-1.45-.48.79-.87,1.74S222.57,467.55,222.37,467.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.25,454.83c-.08.19-1-.08-2.1,0s-2,.48-2.09.3.72-.94,2-1S214.35,454.67,214.25,454.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.48,461.47a3.07,3.07,0,0,0,.09-1.23,6.81,6.81,0,0,0-1.08-3.18,6.28,6.28,0,0,0-1.59-1.68,1.39,1.39,0,0,0-1.37-.24,1.55,1.55,0,0,0-.81,1.33,5.35,5.35,0,0,0,3.58,4.72,5.09,5.09,0,0,0,5.49-1.63,3.62,3.62,0,0,0,.73-1.25,1.36,1.36,0,0,0,0-.8,1,1,0,0,0-.56-.59,1.72,1.72,0,0,0-1.26.13,6.57,6.57,0,0,0-1,.54,8.57,8.57,0,0,0-2.33,2.3,3.53,3.53,0,0,0-.56,1.08,11.88,11.88,0,0,1,3.1-3c.54-.31,1.26-.76,1.83-.56.26.1.36.4.24.75a3.37,3.37,0,0,1-.64,1,4.64,4.64,0,0,1-4.92,1.43,4.83,4.83,0,0,1-3.22-4.1,1,1,0,0,1,.48-.88.94.94,0,0,1,.9.18,6,6,0,0,1,1.52,1.5,7.05,7.05,0,0,1,1.18,3C214.45,461,214.43,461.47,214.48,461.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.73 455.38 182.42 460.56 181.96 472.27 166.71 472.64 166.17 460.56 167.9 453.39 181.73 455.38",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.42,471.39c-.09,0,.13-3.58.49-8s.73-8,.83-8-.13,3.57-.49,8S174.51,471.38,174.42,471.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.02 470.32 166.61 470.5 166.61 472.64 182.03 472.62 182.02 470.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.65,463.59A2.24,2.24,0,0,1,167,463a10.95,10.95,0,0,1,3.82-3.1,8.12,8.12,0,0,1,9.51,1.75,7.39,7.39,0,0,1,1.11,1.66c.2.43.27.68.24.69a16,16,0,0,0-1.59-2.12,8.14,8.14,0,0,0-5.72-2.35,9.35,9.35,0,0,0-5.8,2.27C167.34,462.81,166.72,463.64,166.65,463.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.35,128.72l-.16,52.72,22.62,1.08.65-12.83s8,1.6,10.11-5.86c1.32-4.77,1-41.6,1-41.6Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.54,125.94c-3.56,1-4.34,6.84-4.34,6.84l-5.58,12.35c-2.85-2.23-6.67-2.11-7.4,2.9-.52,3.61,4,4.34,4,4.34-2.61,4.46-4.39,8.06-8.2,12.29-4.12,4.59-6.43,5.05-10.9,5.12h-4.93s-2.41-7.83-6.88-27.43c-5-21.73,20.74-18.93,25.51-24.48C200.55,108.83,222.77,122.73,211.54,125.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.75,144.4c-4.17-2.79-4.55-10.62-2.12-15.32a15.09,15.09,0,0,1,12.84-8,5.88,5.88,0,0,0,2.09-.24,5.67,5.67,0,0,0,2.25-2.13c3.73-4.84,7.39-9.6,14.33-9.6a7.89,7.89,0,0,1,4.36,1.08,6.85,6.85,0,0,1,2.62,3.47,15,15,0,0,1,4.06-1.46,5,5,0,0,1,4.07,1,3.06,3.06,0,0,1,.64,3.9,4.94,4.94,0,0,1,4.93,4.1c.37,2.31-2.95,3.94-3.3,4.12,0,0,1.82,3.81-2.52,6.1-1.74.92-4-.19-4.28-.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.26,149.47a10.65,10.65,0,0,1-1.73,7.68c-.15-.08.58-1.69,1-3.8S184.09,149.48,184.26,149.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,146.89a9.78,9.78,0,0,1-.21,3.85,9.42,9.42,0,0,1-1.2,3.67,21.29,21.29,0,0,1,.63-3.77A19.64,19.64,0,0,1,187,146.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.83,138.19c0,.07-.59.54-1.4,1.49a14.6,14.6,0,0,0-2.44,4.21,35.78,35.78,0,0,0-1.35,4.74,7.59,7.59,0,0,1-.56,2,7.48,7.48,0,0,1,.16-2.07,23.09,23.09,0,0,1,1.22-4.87,12.11,12.11,0,0,1,2.67-4.27A4.28,4.28,0,0,1,194.83,138.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,132.26a3.13,3.13,0,0,1,.44,1.43,9.55,9.55,0,0,1-.2,3.6,9.41,9.41,0,0,1-1.53,3.27c-.55.74-1,1.09-1.06,1.05a19.67,19.67,0,0,0,2-4.46C198.37,134.51,197.82,132.29,198,132.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,145.43c-.08.14-.77-.1-1.54-.54s-1.35-.9-1.27-1,.77.1,1.54.53S171.08,145.29,171,145.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.93,139.8c.15,0,.06,1.14-.65,2.29s-1.64,1.76-1.73,1.64.61-.87,1.24-1.93S181.77,139.76,181.93,139.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.29,138a4.48,4.48,0,0,1-1,2.74c-.9,1.37-2,2.11-2.13,2s.81-1,1.66-2.31A23.39,23.39,0,0,1,185.29,138Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,115.92s-.42-.33-1.24-.79a8.3,8.3,0,0,0-3.79-1,10.2,10.2,0,0,0-5.56,1.49,13.8,13.8,0,0,0-4.73,5.28,23.78,23.78,0,0,0-1.93,4.94l-.09.33-.3-.16a11.3,11.3,0,0,0-5-1.29,12,12,0,0,0-4.1.62,18,18,0,0,0-3.36,1.68,3.65,3.65,0,0,1,.76-.67,10.25,10.25,0,0,1,2.48-1.33,11.78,11.78,0,0,1,9.53.51l-.4.17a23.44,23.44,0,0,1,1.95-5.07,14,14,0,0,1,5-5.46,10.26,10.26,0,0,1,5.85-1.44,8,8,0,0,1,3.89,1.19,5.87,5.87,0,0,1,.86.69C201.92,115.8,202,115.9,202,115.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.89,118.79s.62-.17,1.29.58a2.22,2.22,0,0,1,.52,1.65,2.51,2.51,0,0,1-1.31,1.88,3.71,3.71,0,0,1-2.75.38,8.06,8.06,0,0,1-2.83-1.37A27.74,27.74,0,0,0,206,120a11.42,11.42,0,0,0-3.34-1.18,14.06,14.06,0,0,0-6.82.47,18.82,18.82,0,0,0-5,2.56,50,50,0,0,0-4,3.41,5.06,5.06,0,0,1,.89-1.12,22.75,22.75,0,0,1,2.89-2.62,18.18,18.18,0,0,1,5.12-2.73,14.25,14.25,0,0,1,7.09-.53,11.94,11.94,0,0,1,3.5,1.24,27,27,0,0,1,2.81,2,7.86,7.86,0,0,0,2.64,1.34,3.35,3.35,0,0,0,2.44-.27,2.27,2.27,0,0,0,1.2-1.57,2.09,2.09,0,0,0-.38-1.47A1.93,1.93,0,0,0,213.89,118.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.6,143.82l-18.44,37.06-43.49,2.22,1.79,24s48.47-3.22,53.36-9c5.3-6.23,17.88-44.49,17.89-44.61s1.52-4.48,1.5-4.49Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.18,149.37l3.73-8.08c1.48-5.12,6.33-14.91,6.33-14.91s8.32-9.32,9.41-9,1.65,1.43.53,2.84-5.2,8.4-5.2,8.4,2.33.44,2.61,1.94a4,4,0,0,1-.1,2.3s2.19.61,2.91,1.68a6.13,6.13,0,0,1,.9,2.09,1.75,1.75,0,0,1,1.65,1.42,9.09,9.09,0,0,1,.36,2.88s-2.91,4.86-4.32,5.64-3.32,1.73-3.32,1.73l-3.07,8.2",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.59,389c.14-1.48.21-2.61.21-3.32l4.54-72.49s-3.82-21.16-5.62-26.78l-16.23-6.28-21.62,8.42c-.15-1.74-.23-2.82-.23-2.82l-31.85,11s-.83,21.73,0,28.34c.26,2.13,1.1,7.62,2.11,14.08h0s1,14.06,1.23,14.84c.77,2.87,1,9.89,1,16.92,0,8.93.49,19.57,1,24.62s.83,60.64.83,60.64h23.5l3-88.54c.51-9.48,1.27-24,1.75-34.49l5.52,32.69c0,1.2,3.36,19.89,3.36,19.89a175.44,175.44,0,0,0-1.44,17.73c-.39,16.48-2.32,52.72-2.32,52.72h23s6.91-52.33,8.25-67.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.55,308.8a8.85,8.85,0,0,1-2.12-1.13,29.35,29.35,0,0,1-8.29-8,8.64,8.64,0,0,1-1.2-2.08,17,17,0,0,1,1.48,1.88,42.26,42.26,0,0,0,3.81,4.27,41.58,41.58,0,0,0,4.4,3.67A15.64,15.64,0,0,1,229.55,308.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.94,317.55a3.13,3.13,0,0,1-.45-.73,20.65,20.65,0,0,1-1-2.09,34.32,34.32,0,0,1-2.14-7.33,33.92,33.92,0,0,1-.46-7.62,21.6,21.6,0,0,1,.22-2.31,2.5,2.5,0,0,1,.18-.83c.08,0,0,1.21-.05,3.15a40.73,40.73,0,0,0,2.58,14.81C186.5,316.42,187,317.51,186.94,317.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,349.26a6.52,6.52,0,0,1-.3-1.26c-.17-.92-.38-2.08-.64-3.47l-1.92-11.47c-1.3-8.13-2.19-13.66-2.6-16.24a24.29,24.29,0,0,1,1.11,4.7c.56,2.92,1.27,7,2,11.46s1.35,8.55,1.78,11.5c.19,1.39.35,2.56.47,3.49A5.67,5.67,0,0,1,192,349.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.49,228.75s-3.1,21.84-3.68,29.5c-.35,4.61,4.33,10.73,7.9,11.17s15.62,1.17,15.62,1.17l1-13.7-.31-2.73-3.74-.7.46-22.05Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.91,232.08a4.63,4.63,0,0,1,.14,1.19c.06.77.11,1.88.14,3.25.06,2.74,0,6.54-.24,10.72s-.57,7.95-.84,10.68c-.14,1.37-.26,2.47-.35,3.23a5,5,0,0,1-.21,1.18,6.21,6.21,0,0,1,0-1.2c0-.87.12-2,.19-3.24.19-2.85.43-6.57.69-10.68s.36-8,.39-10.69c0-1.28,0-2.37,0-3.24A6.36,6.36,0,0,1,153.91,232.08Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.12,180.88c.62-.16-32.84-3.58-32.84-3.58a112.36,112.36,0,0,0-16.39-.72H175.06s-27.67,8.16-32.24,15.68L131,227.81l23.44,3.54h0l2.92,25.54s-2.91,29.57-2.91,33.86a31.34,31.34,0,0,0,.37,5.94s46.45-10.45,58-6.69,14.94,4.79,14.94,4.79-.79-10.37-1.64-17.49l-2.68-35.64-2.12-29.13,25.84-3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.56,232.22c-.08,0-.29-1.5-.78-3.92a71.68,71.68,0,0,0-2.53-9.28,77,77,0,0,0-3.76-8.87l-1.32-2.61a4.2,4.2,0,0,1-.45-1,4.35,4.35,0,0,1,.62.89c.37.58.87,1.45,1.46,2.54a60.64,60.64,0,0,1,3.92,8.86,57.27,57.27,0,0,1,2.41,9.39c.2,1.22.33,2.21.38,2.91A3.78,3.78,0,0,1,153.56,232.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.43,241.72a2.43,2.43,0,0,1-.12.47c-.12.35-.27.79-.44,1.31s-.44,1.27-.76,2.06-.66,1.71-1.11,2.69c-.84,2-2,4.28-3.32,6.79a91.12,91.12,0,0,1-4.89,7.87,90.06,90.06,0,0,1-5.72,7.29c-1.89,2.13-3.67,4-5.24,5.45-.77.75-1.51,1.38-2.15,2s-1.2,1-1.67,1.41l-1.08.87c-.25.19-.39.29-.4.27a1.92,1.92,0,0,1,.33-.35l1-.93c.45-.4,1-.89,1.61-1.48s1.34-1.24,2.08-2c1.54-1.49,3.29-3.36,5.15-5.49s3.77-4.6,5.65-7.28,3.5-5.34,4.9-7.8,2.52-4.76,3.4-6.72c.47-1,.83-1.86,1.17-2.64s.62-1.47.84-2l.52-1.28C198.34,241.86,198.41,241.71,198.43,241.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.16,256.22a72,72,0,0,0-6.46,13.2,58.57,58.57,0,0,0,16.83-22.35C187.15,248.75,183.67,252.25,181.16,256.22Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.87,200.36a2.89,2.89,0,0,1-.72,0l-2.06-.07c-1.78-.08-4.36-.18-7.55-.27-6.37-.18-15.19-.22-24.91.21s-18.5,1.27-24.84,2c-3.17.38-5.73.7-7.49.94l-2,.26a6.36,6.36,0,0,1-.72.06,3,3,0,0,1,.7-.16l2-.36c1.76-.3,4.31-.68,7.48-1.1,6.33-.85,15.11-1.74,24.85-2.18s18.57-.33,25-.05c3.19.13,5.77.28,7.55.43l2.05.17A4.71,4.71,0,0,1,214.87,200.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,179.65a2.25,2.25,0,0,1-.61,0l-1.73,0c-1.51,0-3.68,0-6.37.07-5.38.09-12.81.41-21,1.08s-15.57,1.54-20.92,2.17l-6.33.75-1.72.19a3.11,3.11,0,0,1-.61,0,2.28,2.28,0,0,1,.59-.14l1.71-.28c1.49-.23,3.65-.55,6.32-.91,5.33-.73,12.72-1.65,20.92-2.33s15.64-.93,21-.93c2.7,0,4.88,0,6.38.09l1.74.08A3.23,3.23,0,0,1,214,179.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.82,210.51a5.4,5.4,0,0,1-.75-1,28.52,28.52,0,0,1-1.74-3,39.06,39.06,0,0,1-2-4.74,42,42,0,0,1-1.57-6.1,40.9,40.9,0,0,1-.57-6.28,37,37,0,0,1,.3-5.14,28.53,28.53,0,0,1,.62-3.41,6.92,6.92,0,0,1,.36-1.22c.1,0-.32,1.78-.61,4.67a41.54,41.54,0,0,0-.19,5.09,45.62,45.62,0,0,0,.6,6.2,46.28,46.28,0,0,0,1.52,6,41.24,41.24,0,0,0,1.89,4.72C227.91,209,228.9,210.46,228.82,210.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.83,209.16a5.67,5.67,0,0,1-.55-1c-.33-.65-.75-1.62-1.22-2.83a41.18,41.18,0,0,1-2.24-20.07,29.75,29.75,0,0,1,.56-3,4.48,4.48,0,0,1,.33-1.08c.09,0-.25,1.59-.52,4.16a46.25,46.25,0,0,0,2.22,19.9C239.24,207.66,239.92,209.12,239.83,209.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.36,221.52a14.9,14.9,0,0,1-2.61,0l-6.3-.08c-2.46,0-4.69-.11-6.3-.23a12,12,0,0,1-2.6-.31,14.34,14.34,0,0,1,2.62-.06l6.29.08c2.46,0,4.69.12,6.3.23A12.32,12.32,0,0,1,151.36,221.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.51,208a9.82,9.82,0,0,1-2.88.14,7.13,7.13,0,0,1-2.87-.38,9.87,9.87,0,0,1,2.88-.14A7.13,7.13,0,0,1,143.51,208Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.9,222.81c0,.14-15.1.59-33.73,1s-33.74.62-33.74.48,15.1-.59,33.73-1S220.89,222.67,220.9,222.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.8,246.8a10.18,10.18,0,0,1-1.56.16c-1,.07-2.46.14-4.26.21-3.6.13-8.58.2-14.07.06s-10.46-.45-14-.76c-1.79-.15-3.24-.29-4.24-.42a9.34,9.34,0,0,1-1.55-.23,8.83,8.83,0,0,1,1.56,0l4.26.26c3.59.21,8.55.46,14,.6s10.45.13,14.05.09l4.26,0A8.44,8.44,0,0,1,195.8,246.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,247.05a26,26,0,0,1-3.65-.09l-8.77-.47-8.78-.45a27.13,27.13,0,0,1-3.63-.29,3.34,3.34,0,0,1,1-.07c.63,0,1.54,0,2.67,0,2.25,0,5.36.12,8.79.3s6.53.41,8.77.62c1.12.11,2,.2,2.65.28A4,4,0,0,1,223,247.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.58,271.36c0,.15-5.21.19-11.64.11s-11.64-.27-11.64-.41,5.21-.19,11.64-.11S179.59,271.22,179.58,271.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.28,271.65a8.55,8.55,0,0,1-1.58-.07l-4.28-.36c-3.61-.31-8.6-.73-14.12-1.12s-10.53-.67-14.15-.87l-4.29-.24a8.41,8.41,0,0,1-1.57-.15,10.39,10.39,0,0,1,1.58,0c1,0,2.48,0,4.3.08,3.63.1,8.64.32,14.16.71s10.52.87,14.13,1.28c1.8.2,3.26.38,4.26.52A10.08,10.08,0,0,1,224.28,271.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.43,292.11a5.51,5.51,0,0,1-.65-.38c-.42-.27-1-.65-1.87-1.1a35.5,35.5,0,0,0-7.34-3,51,51,0,0,0-11.6-1.83,137.1,137.1,0,0,0-14.45.26c-5.13.28-10,.56-14.44,1a109.48,109.48,0,0,0-11.67,1.72,75.55,75.55,0,0,0-7.69,2c-.9.27-1.57.55-2.05.69a4.08,4.08,0,0,1-.72.22,3.92,3.92,0,0,1,.68-.31c.47-.18,1.13-.49,2-.79a62.63,62.63,0,0,1,7.67-2.2A102.51,102.51,0,0,1,177,286.6c4.43-.46,9.32-.76,14.45-1a129.81,129.81,0,0,1,14.5-.22,50.78,50.78,0,0,1,11.69,2,33,33,0,0,1,7.33,3.17,20.22,20.22,0,0,1,1.83,1.18A3.28,3.28,0,0,1,227.43,292.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.36,179.65a11.15,11.15,0,0,0-1.81,4.33,15.06,15.06,0,0,0,0,5.1,58.13,58.13,0,0,0,1.46,6.16c1.19,4.34,2.45,8.23,3.4,11,.46,1.32.84,2.43,1.15,3.31a6.48,6.48,0,0,1,.37,1.23,6.16,6.16,0,0,1-.56-1.16c-.33-.76-.78-1.87-1.3-3.25-1-2.77-2.37-6.65-3.57-11a55.84,55.84,0,0,1-1.43-6.22,14.85,14.85,0,0,1,.09-5.24,9.49,9.49,0,0,1,1.33-3.27A3.54,3.54,0,0,1,214.36,179.65Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405,271.08c-10.48,5.43-18.52,14.78-24.3,25.08s-9.51,21.59-13.2,32.8l-3.22,57.84c12.19-20.75,22-45.15,24.63-69.07L380.8,317c5.45-.84,10-4.78,12.92-9.46s4.4-10.06,5.86-15.37l-9.9,1.47A36.66,36.66,0,0,0,405,271.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M405,271.08c-10.48,5.43-18.52,14.78-24.3,25.08s-9.51,21.59-13.2,32.8l-3.22,57.84c12.19-20.75,22-45.15,24.63-69.07L380.8,317c5.45-.84,10-4.78,12.92-9.46s4.4-10.06,5.86-15.37l-9.9,1.47A36.66,36.66,0,0,0,405,271.08Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M362.48,400.36s-26.48-31.7-26.17-61.95H347s-11.61-7.64-10.7-11.92S337.53,306,337.53,306l9.78,2.44S340,304.8,339.06,299s2.14-32.7,2.14-32.7,11.91,12.53,15.58,25.37,13.29,27.8,10.47,66.92S362.48,400.36,362.48,400.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.9,403.35s28.69-19.11,35.06-43.5l-8.6-2.34s11-3.6,11.21-7.24,3.5-16.73,3.5-16.73l-8.4-.18s6.7-1.34,8.71-5.81,5.43-26.75,5.43-26.75-12.32,7.46-18.08,17S388,337.23,381.67,369.29,375.9,403.35,375.9,403.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.43,293.92a1.89,1.89,0,0,1,.1.33c.05.25.13.57.23,1l.84,3.76c.37,1.63.8,3.63,1.26,6s1,5,1.56,7.93c1.13,5.87,2.33,12.9,3.56,20.71s2.39,16.44,3.45,25.51,1.84,17.74,2.46,25.63,1,15,1.26,21c.15,3,.22,5.69.29,8.07s.12,4.42.14,6.09,0,2.94,0,3.85v1a1.3,1.3,0,0,1,0,.34,1.55,1.55,0,0,1,0-.34c0-.26,0-.59-.05-1,0-.92-.08-2.21-.14-3.85s-.11-3.72-.22-6.09-.2-5.08-.37-8.07c-.28-6-.75-13.08-1.36-21s-1.47-16.54-2.51-25.61-2.23-17.67-3.4-25.49-2.37-14.85-3.45-20.73c-.52-2.94-1-5.6-1.49-7.93s-.83-4.34-1.17-6-.57-2.89-.74-3.78l-.19-1A2.12,2.12,0,0,1,348.43,293.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.81,419.76s-24.23-27.49-31.76-44.11l5.68-2.43c-4.11.68-8.33-1.09-11.52-3.77s-5.54-6.22-7.84-9.71l7.48-1.26a27.78,27.78,0,0,1-16.34-12.66c8.82,1.45,16.81,6.3,23.39,12.36a116.42,116.42,0,0,1,14.18,16.43,55.37,55.37,0,0,1,5.51,9.05C351.66,392.08,358.82,409.67,358.81,419.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.34,316.8a1.27,1.27,0,0,1-.11.28c-.09.21-.22.47-.37.8-.35.73-.85,1.75-1.47,3.05-1.3,2.64-3.14,6.48-5.36,11.24s-4.81,10.48-7.57,16.86-5.65,13.46-8.56,20.94-5.48,14.68-7.75,21.25-4.19,12.53-5.74,17.56-2.79,9.1-3.6,11.93l-1,3.24-.27.84c-.06.19-.1.29-.1.29a1.24,1.24,0,0,1,0-.3c.06-.22.13-.5.21-.85l.87-3.28c.76-2.84,1.93-6.94,3.44-12s3.42-11,5.64-17.61,4.84-13.79,7.73-21.28,5.84-14.56,8.6-20.94,5.4-12.08,7.67-16.82,4.16-8.57,5.52-11.18c.66-1.28,1.18-2.29,1.56-3,.17-.32.31-.57.41-.78S411.33,316.79,411.34,316.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.86,431.54a1.66,1.66,0,0,1-.12-.5c-.06-.39-.14-.88-.24-1.46-.18-1.27-.5-3.1-.94-5.35s-1.06-4.9-1.86-7.83-1.82-6.09-3.05-9.36-2.59-6.31-3.9-9-2.62-5.13-3.78-7.1-2.12-3.57-2.82-4.64l-.79-1.26a.26.26,0,1,1,.09-.06c.23.33.52.72.87,1.2.75,1.05,1.77,2.6,3,4.57s2.53,4.36,3.89,7.07,2.71,5.79,4,9.08,2.23,6.48,3,9.42,1.36,5.62,1.75,7.89.66,4.1.79,5.38c.05.59.1,1.08.14,1.48A2,2,0,0,1,360.86,431.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.8,
    y: 425.08,
    width: 53.03,
    height: 10.82,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.86 435.89 350.59 472.28 382.64 472.28 387.98 435.89 344.86 435.89",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.58,435.89c0,.15-10,.26-22.4.26s-22.41-.11-22.41-.26,10-.26,22.41-.26S389.58,435.75,389.58,435.89Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendenteAvaliacao);
export default __webpack_public_path__ + "static/media/PendenteAvaliacao.d6192a01c234895f0f4cd422d364e03b.svg";
export { ForwardRef as ReactComponent };